import { render } from "./FormHeadTrainingTable.vue?vue&type=template&id=27eb2244&scoped=true&ts=true"
import script from "./FormHeadTrainingTable.vue?vue&type=script&lang=ts"
export * from "./FormHeadTrainingTable.vue?vue&type=script&lang=ts"

import "./FormHeadTrainingTable.vue?vue&type=style&index=0&id=27eb2244&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27eb2244"]])

export default __exports__